import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, FormikProps } from 'formik';
import { compose } from 'recompose';
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import HelpOutline from '@material-ui/icons/HelpOutline';

import { ContentInput } from 'api';
import { CustomSVG, ValidatedSwitch } from 'components';

interface IPropsEnhanced extends WithStyles<typeof styles> {
  formik: FormikProps<ContentInput>;
}

const styles = (theme: Theme) =>
  createStyles({
    icon: {
      marginRight: theme.spacing(1),
      color: theme.custom.palette.orange,
    },
    help: {
      color: theme.custom.palette.grey3,
    },
  });

const enhancers = compose<IPropsEnhanced, {}>(connect, withStyles(styles));

const MarkImportant: FC<IPropsEnhanced> = ({ classes, formik }) => {
  const { t } = useTranslation();
  const variant = formik.values.is_important ? 'body2' : 'body1';

  return (
    <Grid container alignItems="center" justify="space-between">
      <Grid item container alignItems="center" xs>
        <CustomSVG name="flag" className={classes.icon} />
        <Typography variant={variant}>{t('posting:important')}</Typography>
        <Tooltip title={t('posting:importantTooltip')} placement="top">
          <IconButton className={classes.help}>
            <HelpOutline fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <ValidatedSwitch name="is_important" customColor="orange" />
      </Grid>
    </Grid>
  );
};

export default enhancers(MarkImportant);
